

const bookdata = {
    ai:[
            {
                id:'ai1',
                img:'./bookimages/ai/1.jpg',
                title: 'Artificial Intelligence',
                author:'Elaine Rich, Kevin Knight, Shivshankar B Nair'
            },
            {
                id:'ai2',
                img:'./bookimages/ai/2.jpg',
                title: 'Artificial Intelligence',
                author:'Michael Negnevitsky'
            },
            {
                id:'ai3',
                img:'./bookimages/ai/3.jpg',
                title: 'Artificial intelligence For Games',
                author:'IAN MILLINGTON, JOHN FUNGE'
            },
            {
                id:'ai4',
                img:'./bookimages/ai/4.jpg',
                title: 'Encyclopedia Of Artificial Intelligence',
                author:'Juan RamÃƒÂ³n RabuÃƒÂ±al Dopico, JuliÃƒÂ¡n Dorado de la Calle,& Alejandro Pazos Sierra'
            },
            {
                id:'ai5',
                img:'./bookimages/ai/5.jpg',
                title: 'Artificial Intelligence By Example',
                author:'Denis Rothman'
            },
            {
                id:'ai6',
                img:'./bookimages/ai/6.jpg',
                title: 'Artificial Intelligence Illuminated',
                author:'Ben Coppin'
            },
            {
                id:'ai7',
                img:'./bookimages/ai/7.jpg',
                title: 'Artificial Intelligence For Dummies',
                author:'John Paul Mueller, Luca Massaron'
            },
            {
                id:'ai8',
                img:'./bookimages/ai/8.jpg',
                title: ' Artificial Intelligence Applications and Innovations',
                author:'Max Bramer and Vladan Devedzic'
            },
            {
                id:'ai9',
                img:'./bookimages/ai/9.jpg',
                title: 'Artificial Intelligence and Machine Learning Fundamentals',
                author:'Zsolt Nagy'
            },
            {
                id:'ai10',
                img:'./bookimages/ai/10.jpg',
                title: 'Artificial Intelligence for Big Data',
                author:'Anand Deshpande and Manish Kumar'
            },
           
            {
                id:'ai11',
                img:'./bookimages/ai/11.jpg',
                title: 'Artificial Intelligence in Financial Markets',
                author:'Christian L. Dunis,Peter W. Middleton,Konstantinos Theofi latos,Andreas Karathanasopoulos'
            },
            {
                id:'ai12',
                img:'./bookimages/ai/12.jpg',
                title: 'Artificial Intelligence with the Raspberry Pi',
                author:'Donald J. Norris'
            },
            {
                id:'ai13',
                img:'./bookimages/ai/13.jpg',
                title: 'Beyond Artificial Intelligence',
                author:'Alain Cardon'
            },
            {
                id:'ai14',
                img:'./bookimages/ai/14.jpg',
                title: 'The Elements of Artificial Intelligence',
                author:'Steven L. Tanimoto'
            }
            


           


        ],

        clanguage:[
            {
                id:'c1',
                img:'./bookimages/c/1.jpg',
                title: '21st Century C',
                author:'Ben Klemens'
            },
            {
                id:'c2',
                img:'./bookimages/c/2.jpg',
                title: 'Algorithms in C',
                author:'Robert Sedgewick'
            },
            {
                id:'c3',
                img:'./bookimages/c/3.jpg',
                title: 'C In A Nutshell',
                author:'Peter Prinz and Tony Crawford'
            }
            // ,
            // {
            //     img:'https://csbookspdf.orgfree.com/book%20images/ai/1.jpg',
            //     title: 'i',
            //     author:'satir billa'
            // }
            // ,
            // {
            
            //     img:'https://csbookspdf.orgfree.com/book%20images/ai/1.jpg',
            //     title: 'j',
            //     author:'kutriya'
            // }


        ],

        cpp:[
            {
                id:'cpp1',
                img:'./bookimages/cpp/1.jpg',
                title: 'Accelerated C++',
                author:'Andrew Koenig & Barbara E. Moo'
            },
            {
                id:'cpp2',
                img:'./bookimages/cpp/2.jpg',
                title: 'A Tour of C++',
                author:'Bjarne Stroustrup'
            },
            {
                id:'cpp3',
                img:'./bookimages/cpp/3.jpg',
                title: 'C++ The Complete Reference',
                author:'Herb Schildt'
            },
            {
                id:'cpp4',
                img:'./bookimages/cpp/4.jpg',
                title: 'C++ for Dummiees',
                author:'Stephen R. Davis'
            },
            {
                id:'cpp5',
                img:'./bookimages/cpp/5.jpg',
                title: 'C++ Primer',
                author:'Stanley B.Lippman, Josee Lajoie, Barbara E. Moo'
            }
        ],
        csharp:[
            {
                id:'cshp1',
                img:'./bookimages/csharp/1.jpg',
                title: 'Learn C# in One Day',
                author:'Jamie Chan'
            },
            {
                id:'cshp2',
                img:'./bookimages/csharp/2.jpg',
                title: 'Head First C#',
                author:'Andrew Stellman, Jennifer Greene'
            },
            {
                id:'cshp3',
                img:'./bookimages/csharp/3.jpg',
                title: 'Functional Programming in C#',
                author:'Enrico Buonanno'
            },
            {
                id:'cshp4',
                img:'./bookimages/csharp/4.jpg',
                title: 'c# in Depth',
                author:'Jon Skeet, Eric Lipperi'
            },
            // {
            //     id:'cshp5',
            //     img:'./bookimages/cpp/5.jpg',
            //     title: 'C++ Primer',
            //     author:'Stanley B.Lippman, Josee Lajoie, Barbara E. Moo'
            // }
        ]
    }
        


export default bookdata